import React, { useContext, useState, useEffect } from 'react';
import { Dropdown } from '../../atoms';
import { ReactComponent as CalendarIcon } from '../../../assets/svg/calendar.svg';
import './report-schedule.scss';
import { default as t } from '../../../utils/i18n';
import { ReportsService } from '../../../services';
import { UserContext } from '../../../context';

const ReportSchedule = ({
  handleOpenSliderModal,
  reportId,
  frequencyMapping,
  getReportResponse,
}) => {
  const [frequency, setFrequency] = useState('');
  const [limitData, setLimitData] = useState('');
  const [dateOfMonth, setDateOfMonth] = useState('');
  const [monthlyRecurrence, setMonthlyRecurrence] = useState('');
  const { user } = useContext(UserContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const monthoption = [
    {
      value: 1,
      label: 1,
    },
    {
      value: 2,
      label: 2,
    },
    {
      value: 3,
      label: 3,
    },
  ];
  const weekoption = [
    {
      value: 0,
      label: t('report.summart.sun'),
    },
    {
      value: 1,
      label: t('report.summart.mon'),
    },
    {
      value: 2,
      label: t('report.summart.tue'),
    },
    {
      value: 3,
      label:t('report.summart.wed'),
    },
    {
      value: 4,
      label: t('report.summart.thu'),
    },
    {
      value: 5,
      label: t('report.summart.fri'),
    },
    {
      value: 6,
      label: t('report.summart.sat'),
    }
  ];
  const frequencyoption = [
    {
      value: 30,
      label: t('report.summary.monthly'),
    },
    {
      value: 7,
      label: t('report.summary.weekly'),
    },
    {
      value: 15,
      label: t('report.summary.fortnightly'),
    },
  ];
  const handleFrequency = selectedOption => {
    setLimitData('');
    setDateOfMonth(null);
    setMonthlyRecurrence('');
    setFrequency(selectedOption);
  };
  const handleTime = selectedOption => {
    setLimitData(selectedOption);
  };
  const scheduleReport = async () => {
    try {
      const payload = {
        frequency: frequency?.value,
        deliverySchedule: {
          dayOfWeek: limitData ? limitData?.value : null,
          dateOfMonth: dateOfMonth ? +dateOfMonth : null,
          monthlyRecurrence: monthlyRecurrence ? monthlyRecurrence?.value : null,
        },
      };
      const reportResponse = await ReportsService.updateReportDetails(
        userAccessToken,
        username,
        payload,
        reportId
      );
      const reportData = reportResponse?.data?.data;
      setFrequency('');
      handleOpenSliderModal(true);
      getReportResponse();
    } catch (error) {}
  };

  const checkDisabled = () => {
    let isDisable = true;
    if (frequency?.value === 30 && monthlyRecurrence?.value && dateOfMonth) {
      isDisable = false;
    } else if (frequency?.value && limitData !== '') {
      isDisable = false;
    }
    return isDisable;
  };
  useEffect(() => {
    if (frequencyMapping?.frequency) {
      setFrequency({
        value: frequencyMapping?.frequency,
        label: frequencyoption.find(x => x.value === frequencyMapping?.frequency).label,
      });
      if (frequencyMapping?.frequency === 30) {
        setDateOfMonth(frequencyMapping?.deliverySchedule?.dateOfMonth);
        setMonthlyRecurrence({
          value: frequencyMapping?.deliverySchedule?.monthlyRecurrence,
          label: frequencyMapping?.deliverySchedule?.monthlyRecurrence,
        });
      } else {
        setLimitData({
          value: frequencyMapping?.deliverySchedule?.dayOfWeek,
          label: weekoption.find(x => x.value === frequencyMapping?.deliverySchedule?.dayOfWeek)
            ?.label,
        });
      }
    }
  }, [frequencyMapping?.frequency]);
  return (
    <div className="report-schedule-container">
      <div className="heading-container-modal edit-label">
        <div className="flexbox">
          <CalendarIcon />
          <p>{t('report.table.schedule.report')}</p>
        </div>
        <div
          onClick={() => {
            setFrequency('');
            handleOpenSliderModal(true);
          }}
        >
          <i
            data-tip="Edit nickname"
            data-for="tool-tip"
            className="eva eva-close-outline clear-icon close-btn"
            currentitem="false"
          ></i>
        </div>
      </div>
      <div>
        <div className="frequency">
          <Dropdown
            className="user-select"
            heading={t('report.summary.period')}
            value={frequency}
            options={frequencyoption}
            onSelect={handleFrequency}
            placeholder={t('report.summary.freq.period')}
          />
        </div>
        {frequency.value === 7 || frequency.value === 15 ? (
          <div className="frequency">
            <Dropdown
              className="user-select"
              heading={t('report.summary.select.day')}
              value={limitData}
              options={weekoption}
              onSelect={handleTime}
              placeholder={t('report.summary.select.day')}
            />
          </div>
        ) : (
          ''
        )}

        {frequency.value === 30 ? (
          <>
            <div className="frequency">
              <Dropdown
                className="user-select"
                heading={t('report.summary.monthly.recurrence')}
                value={monthlyRecurrence}
                options={monthoption}
                onSelect={e => setMonthlyRecurrence(e)}
                placeholder={t('report.summary.monthly.recurrence')}
              />
            </div>
            <div>
              <div className="form-input">
                <label>{t('report.summary.select.day.of.month')}</label>
                <div className="input-field-wrapper">
                  <input
                    className="form-control input-field"
                    name="day"
                    type="number"
                    value={dateOfMonth}
                    onChange={e => {
                      let val = e?.target?.value;
                      if (val > 31) {
                        val = 31;
                      }
                      if (val <= 0) {
                        val = 1;
                      }
                      setDateOfMonth(val);
                    }}
                    placeholder={t('report.summary.select.day.of.month')}
                    min="1"
                    max="31"
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          ''
        )}
      </div>
      <div className="button-container">
        <button
          className="cancel-btn"
          onClick={() => {
            setFrequency('');
            handleOpenSliderModal(true);
          }}
        >
          {t('report.summary.cancel')}
        </button>
        <button className={checkDisabled() ? 'create-btn disabled' : 'create-btn' } disabled={checkDisabled()} onClick={e => scheduleReport()}>
          {t('report.summary.schedule')}
        </button>
      </div>
    </div>
  );
};

export default ReportSchedule;
